import { configureStore } from "@reduxjs/toolkit";
import dashboardSlice from "./dashboardSlice";
import getEmailIDSlice from "./getEmailIDSlice";
import addUserSlice from "./addUserSlice";
import accountSlice from "./accountSlice";
import dashboardDataReducer from "./dasboardDataSlice";
import ticketsReducer from "./ticketSlice";

const store = configureStore({
  reducer: {
    dashboard: dashboardSlice,
    email: getEmailIDSlice,
    addUser: addUserSlice,
    account: accountSlice,
    dashboardData: dashboardDataReducer,
    tickets: ticketsReducer,
  },
});
export default store;
